import { useEffect, useElement, useState } from '@nebula.js/stardust';
import type { IStores } from '../store';
import useListBoxResources from './listbox/get-listbox-resources';
import type { IContainerElement } from './types';
import { render, teardown } from '../components/root';
import useGetPreferredSize from './use-get-preferred-size';

export default function useRender(stores: IStores) {
  const [mounted] = useState<{ current: boolean }>({ current: true });
  const { store } = stores;

  const { app, fpLayout } = store.getState();
  const containerElement = <IContainerElement>useElement();

  const isMounted = () => mounted.current;

  const { resourcesReady, destroy } = useListBoxResources(stores, isMounted);

  useEffect(() => {
    mounted.current = true;
    if (!fpLayout || !app || !resourcesReady) {
      return undefined;
    }
    const root = render(containerElement, stores);
    return () => {
      mounted.current = false;
      teardown(root);
      destroy();
    };
  }, [resourcesReady, !fpLayout]);

  useGetPreferredSize(containerElement, fpLayout);
}
